import {
	Box, Flex, Text,
} from '@ascension/web';
import React from 'react';
import { MenuItem } from '@material-ui/core';
import { PaginationComponentProps } from './PaginationComponentProps';
import { Pagination } from '@material-ui/lab';
import { useFilterState } from '../Filters/FiltersContext/FiltersContext';
import { ChatAwareSelect } from '@components/ChatAwareComponents/ChatAwareSelect/ChatAwareSelect';
import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
	pagination: {
		'& .MuiPaginationItem-root.Mui-selected': {
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.common.white,
		},
		'& .MuiPaginationItem-root.Mui-selected:hover': {
			backgroundColor: theme.palette.primary.main,
		},
		'& .MuiPaginationItem-icon': {
			color: theme.palette.primary.main,
		},
	},
}));

export default function PaginationComponent ({ displayPerPage, fontSize }: PaginationComponentProps) {
	const classes = useStyles();
	const options = [
		{ value: '25', label: '25' },
		{ value: '50', label: '50' },
		{ value: '100', label: '100' },
	];
	const { page, size, totalCount, entityName, updateFilterProps } = useFilterState();
	const startNumber= page;
	const defaultPageSize = size;
	const totalCases = Number(totalCount);
	const displayStart = ((startNumber-1)*defaultPageSize)+1;
	const displaySize = totalCases < (defaultPageSize*(startNumber)) ? totalCases : defaultPageSize * startNumber;
	const pageCount = Math.ceil(totalCases / defaultPageSize);

	const handleChangeSize = (newValue: number)=> {
		updateFilterProps({ page: 1, size: Number(newValue) });
	};

	const handlePageChange = (_event: React.ChangeEvent<unknown>, pageNumber: number) => {
		updateFilterProps({ page: pageNumber });
		window.scrollTo(0, 0);
	};

	return (
		<Flex justifyContent="center" data-field="Pagination_Component" >
			<Box
				mt={8}
				flexDirection="column"
				width={1}
				elevated>
				<Flex width={1} alignItems="center" justifyContent="space-between">
					<Flex flexDirection="row" data-field="Data_Information" fontSize={fontSize} alignItems="center">
						<Flex flexDirection="column" maxWidth={180} >
							<Text display="block">Showing <strong>{displayStart} - {displaySize}</strong> of <strong>{totalCases}</strong> {entityName.toLowerCase()}</Text>
						</Flex>
						{displayPerPage &&
						<>
							<Flex flexDirection="column" maxWidth={150} pl="35px" pr="10px">
								<Text display="block">{entityName} per page</Text>
							</Flex>
							<Flex flexDirection="column" maxWidth={50}>
								<Box className={['pagination-dropdown']} data-field="Page_Options">
									<ChatAwareSelect
										value={defaultPageSize.toString()}
										onChange={(e) => handleChangeSize(Number(e.target.value))}
										data-field="Page_Options"
									>
										{options.map((option) => (
											<MenuItem key={option.value} value={option.value}>
												{option.label}
											</MenuItem>
										))}
									</ChatAwareSelect>
								</Box>
							</Flex>
						</>
						}
					</Flex>
					<Box data-field="Pagination_Cmp">
						<Pagination
							count={pageCount}
							page={Number(startNumber)}
							onChange={handlePageChange}
							siblingCount={2}
							boundaryCount={1}
							showFirstButton
							showLastButton
							className={classes.pagination}
						/>
					</Box>
				</Flex>
			</Box>
		</Flex>
	);
}
